import { render, staticRenderFns } from "./BigWithSearchAndButton.vue?vue&type=template&id=106eb9c0&scoped=true&"
import script from "./BigWithSearchAndButton.vue?vue&type=script&lang=js&"
export * from "./BigWithSearchAndButton.vue?vue&type=script&lang=js&"
import style0 from "./BigWithSearchAndButton.vue?vue&type=style&index=0&id=106eb9c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106eb9c0",
  null
  
)

export default component.exports